import { Bell, LayoutGrid, MessageCircle, Search } from 'lucide-react';
import { toAbsoluteUrl } from '@/lib/helpers';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Container } from '@/components/common/container';
import { SearchDialog } from '@/partials/topbar/search-dialog';
import { NotificationsSheet } from '@/partials/topbar/notifications-sheet';
import { ChatSheet } from '@/partials/topbar/chat-sheet';
import { AppsDrawer } from '@/partials/topbar/apps-drawer';
import { UserDropdownMenu } from '@/partials/topbar/user-dropdown-menu';
import { useScrollPosition } from '@/hooks/use-scroll-position';

export function Header() {
  const scrollPosition = useScrollPosition();
  const headerSticky: boolean = scrollPosition > 0;

  return (
    <header
      className={cn(
        'header fixed top-0 z-10 start-0 flex items-stretch shrink-0 border-b border-transparent bg-background end-0 pe-[var(--removed-body-scroll-bar-size,0px)]',
        headerSticky && 'border-b border-border'
      )}
    >
      <Container className="flex justify-between items-stretch lg:gap-4">
        {/* Left Section - Empty for now */}
        <div className="flex items-center">
          {/* Empty space for future breadcrumbs or page title */}
        </div>

        {/* Right Section - Actions */}
        <div className="flex items-center gap-3">
        {/* Search */}
        <SearchDialog
          trigger={
            <Button
              variant="ghost"
              mode="icon"
              shape="circle"
              className="size-9 hover:bg-primary/10 hover:[&_svg]:text-primary"
            >
              <Search className="size-4.5!" />
            </Button>
          }
        />

        {/* Notifications */}
        <NotificationsSheet
          trigger={
            <Button
              variant="ghost"
              mode="icon"
              shape="circle"
              className="size-9 hover:bg-primary/10 hover:[&_svg]:text-primary"
            >
              <Bell className="size-4.5!" />
            </Button>
          }
        />

        {/* Messages/Chat */}
        <ChatSheet
          trigger={
            <Button
              variant="ghost"
              mode="icon"
              shape="circle"
              className="size-9 hover:bg-primary/10 hover:[&_svg]:text-primary"
            >
              <MessageCircle className="size-4.5!" />
            </Button>
          }
        />

        {/* Apps */}
        <AppsDrawer
          trigger={
            <Button
              variant="ghost"
              mode="icon"
              shape="circle"
              className="size-9 hover:bg-primary/10 hover:[&_svg]:text-primary"
            >
              <LayoutGrid className="size-4.5!" />
            </Button>
          }
        />

        {/* User Menu */}
        <UserDropdownMenu
          trigger={
            <img
              className="size-9 rounded-full border-2 border-green-500 shrink-0 cursor-pointer hover:border-primary transition-colors"
              src={toAbsoluteUrl('/media/avatars/300-2.png')}
              alt="User Avatar"
            />
          }
        />
        </div>
      </Container>
    </header>
  );
}
